import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'string',
    standalone: false,
})
export class StringPipe implements PipeTransform {
    transform(val: number): string {
        if (typeof val === 'number') {
            return String(val);
        } else {
            return val;
        }
    }
}
